//TODO Write test
const convertMilesToKm = (mileage: string) => {
  return Math.floor(parseInt(mileage) * 1.60934);
};

export { convertMilesToKm };
